import React from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { Subscription } from '../../../types/subscription';
import {  SubscriptionStatus, PaymentStatus } from '../../../types/enums';
import { LawyerSelectionData } from '../../../services/lawyerService'; // (1) استيراد النوع الجديد
import formStyles from '../trainees/TraineeForm.module.css';

// (2) إضافة lawyer_id إلى النوع ليكون جزءًا من النموذج
type FormInputs = {
  lawyer_id: number;
  start_date: string;
  end_date: string;
  fee: number;
  payment_status: PaymentStatus;
  status?: SubscriptionStatus;
};

interface SubscriptionFormProps {
  onSubmit: SubmitHandler<FormInputs>;
  initialData?: Subscription;
  isEditMode: boolean;
  isSubmitting: boolean;
  lawyers: LawyerSelectionData[]; // (3) قبول قائمة المحامين كـ prop
}

const SubscriptionForm: React.FC<SubscriptionFormProps> = ({ onSubmit, initialData, isEditMode, isSubmitting, lawyers }) => {
  const { register, handleSubmit, formState: { errors } } = useForm<FormInputs>({
    defaultValues: {
      lawyer_id: initialData?.lawyer_id || undefined,
      start_date: initialData?.start_date.split('T')[0] || '',
      end_date: initialData?.end_date.split('T')[0] || '',
      fee: initialData?.fee || 0,
      payment_status: initialData?.payment_status || PaymentStatus.PENDING,
      status: initialData?.status || SubscriptionStatus.PENDING,
    },
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={formStyles.form}>
      {/* (4) عرض معلومات المحامي في وضع التعديل */}
      {isEditMode && initialData ? (
        <div className={formStyles.detailsSection}>
          <p><strong>المحامي:</strong> {initialData.lawyer?.name}</p>
        </div>
      ) : (
        // (5) عرض القائمة المنسدلة في وضع الإضافة
        <div className={formStyles.formField}>
          <label htmlFor="lawyer_id">اختر المحامي</label>
          <select id="lawyer_id" {...register('lawyer_id', { required: 'يجب اختيار محامٍ', valueAsNumber: true })} className={formStyles.input}>
            <option value="">-- اختر محامياً --</option>
            {lawyers.map(lawyer => (
              <option key={lawyer.id} value={lawyer.id}>{lawyer.name}</option>
            ))}
          </select>
          {errors.lawyer_id && <p className={formStyles.error}>{errors.lawyer_id.message}</p>}
        </div>
      )}
      
      {/* باقي حقول النموذج تبقى كما هي */}
      <div className={formStyles.formField}>
        <label htmlFor="start_date">تاريخ البدء</label>
        <input id="start_date" type="date" {...register('start_date', { required: 'تاريخ البدء مطلوب' })} className={formStyles.input} />
        {errors.start_date && <p className={formStyles.error}>{errors.start_date.message}</p>}
      </div>
      <div className={formStyles.formField}>
        <label htmlFor="end_date">تاريخ الانتهاء</label>
        <input id="end_date" type="date" {...register('end_date', { required: 'تاريخ الانتهاء مطلوب' })} className={formStyles.input} />
        {errors.end_date && <p className={formStyles.error}>{errors.end_date.message}</p>}
      </div>
      <div className={formStyles.formField}>
        <label htmlFor="fee">الرسوم</label>
        <input id="fee" type="number" step="0.01" {...register('fee', { required: 'الرسوم مطلوبة', valueAsNumber: true, min: { value: 0, message: 'الرسوم يجب أن تكون موجبة' } })} className={formStyles.input} />
        {errors.fee && <p className={formStyles.error}>{errors.fee.message}</p>}
      </div>
      <div className={formStyles.formField}>
        <label htmlFor="payment_status">حالة الدفع</label>
        <select id="payment_status" {...register('payment_status')} className={formStyles.input}>
          {Object.values(PaymentStatus).map(s => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>
      {isEditMode && (
        <div className={formStyles.formField}>
          <label htmlFor="status">حالة الاشتراك</label>
          <select id="status" {...register('status')} className={formStyles.input}>
            {Object.values(SubscriptionStatus).map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
      )}

      <div className={`${formStyles.buttonContainer} ${formStyles.fullWidth}`}>
        <Link to="/admin/subscriptions/list" className={formStyles.cancelButton}>إلغاء</Link>
        <button type="submit" disabled={isSubmitting} className={formStyles.submitButton}>
          {isSubmitting ? 'جاري الحفظ...' : 'حفظ'}
        </button>
      </div>
    </form>
  );
};

export default SubscriptionForm;
